(function () {
  var jbToastEl = null;
  var jbToastTimeout = null;
  function showToast(message, action) {
    if (!message) return;
    if (!jbToastEl) {
      jbToastEl = document.createElement('div');
      jbToastEl.className = 'jb-toast';
      document.body.appendChild(jbToastEl);
    }
    jbToastEl.innerHTML = '';
    var textSpan = document.createElement('span');
    textSpan.textContent = message;
    jbToastEl.appendChild(textSpan);
    if (action && action.label && typeof action.onClick === 'function') {
      var actionBtn = document.createElement('button');
      actionBtn.type = 'button';
      actionBtn.className = 'jb-toast__action';
      actionBtn.textContent = action.label;
      actionBtn.addEventListener('click', function () {
        clearTimeout(jbToastTimeout);
        jbToastEl.classList.remove('jb-toast--visible');
        action.onClick();
      });
      jbToastEl.appendChild(actionBtn);
    }
    // Force reflow so re-triggering the class restarts the transition even
    // if a previous toast is still fading.
    jbToastEl.classList.remove('jb-toast--visible');
    void jbToastEl.offsetWidth;
    jbToastEl.classList.add('jb-toast--visible');
    clearTimeout(jbToastTimeout);
    jbToastTimeout = setTimeout(function () {
      jbToastEl.classList.remove('jb-toast--visible');
    }, action ? 4500 : 2600);
  }

  function initTimers() {
    document.querySelectorAll('[data-jb-timer]').forEach(function (el) {
      var mode = el.getAttribute('data-mode');
      var end;
      if (mode === 'daily') {
        end = new Date();
        end.setHours(23, 59, 59, 0);
      } else {
        end = new Date(el.getAttribute('data-end'));
        if (isNaN(end.getTime())) {
          end = new Date();
          end.setHours(23, 59, 59, 0);
        }
      }
      var h = el.querySelector('[data-jb-h]');
      var m = el.querySelector('[data-jb-m]');
      var s = el.querySelector('[data-jb-s]');

      function tick() {
        var diff = end.getTime() - Date.now();
        if (diff <= 0 && mode === 'daily') {
          end.setDate(end.getDate() + 1);
          diff = end.getTime() - Date.now();
        }
        diff = Math.max(0, diff);
        var totalSec = Math.floor(diff / 1000);
        var hh = Math.floor(totalSec / 3600);
        var mm = Math.floor((totalSec % 3600) / 60);
        var ss = totalSec % 60;
        h.textContent = String(hh).padStart(2, '0');
        m.textContent = String(mm).padStart(2, '0');
        s.textContent = String(ss).padStart(2, '0');
        if (diff > 0) requestAnimationFrame(function () { setTimeout(tick, 250); });
      }
      tick();
    });
  }

  function initPickers() {
    document.querySelectorAll('[data-jb-picker]').forEach(function (picker) {
      var max = parseInt(picker.getAttribute('data-max'), 10) || 7;
      var currentPrice = picker.getAttribute('data-bundle-price') || '';
      var stickybar = picker.parentElement.querySelector('[data-jb-stickybar]');
      var countEl = stickybar ? stickybar.querySelector('[data-jb-count]') : null;
      var priceEl = stickybar ? stickybar.querySelector('[data-jb-price]') : null;
      var checkoutBtn = stickybar ? stickybar.querySelector('[data-jb-checkout]') : null;
      var checkoutLabelEl = checkoutBtn ? checkoutBtn.querySelector('[data-jb-checkout-label]') : null;
      var subtextEl = picker.querySelector('[data-jb-subtext]');
      var subtextTemplate = subtextEl ? (subtextEl.getAttribute('data-subtext-template') || subtextEl.textContent) : '';
      var countTemplate = (stickybar && stickybar.getAttribute('data-count-template')) || 'Selected [selected] of [max] pieces.';
      var maxAlertTemplate = (stickybar && stickybar.getAttribute('data-alert-max')) || 'You can only choose [max] pieces.';
      var errorText = (stickybar && stickybar.getAttribute('data-error-text')) || 'Something went wrong. Please try again.';
      var addingText = (stickybar && stickybar.getAttribute('data-adding-text')) || 'Adding...';
      var checkoutLabel = checkoutLabelEl ? checkoutLabelEl.textContent : (checkoutBtn ? checkoutBtn.textContent : '');
      var selected = new Set();
      // True only if syncFromCart found this collection already represented
      // in the cart at page load (e.g. shopper hit Back from checkout).
      // When it's false, we know for certain the cart has none of this
      // collection's items yet, so checkout can skip straight to adding
      // instead of spending a round trip checking what to remove first --
      // shaves a network hop off the most common path (first-time pick).
      var cartMightBeStale = false;

      function refresh() {
        if (countEl) {
          // Compact "selected/max" badge -- numerals need no translation.
          countEl.textContent = selected.size + '/' + max;
        }
        if (priceEl) priceEl.textContent = currentPrice;
        if (checkoutBtn) {
          checkoutBtn.disabled = selected.size !== max;
          checkoutBtn.setAttribute(
            'aria-label',
            countTemplate.replace('[selected]', selected.size).replace('[max]', max) + ' ' + checkoutLabel
          );
        }
      }

      var tierWrap = picker.querySelector('[data-jb-tiers]');

      function activateTier(tierBtn) {
        if (tierWrap) {
          tierWrap.querySelectorAll('.jb-tier-btn').forEach(function (b) { b.classList.remove('is-active'); });
        }
        tierBtn.classList.add('is-active');
        var newMax = parseInt(tierBtn.getAttribute('data-tier-count'), 10) || max;
        var newPrice = tierBtn.getAttribute('data-tier-price') || currentPrice;

        if (selected.size > newMax) {
          // Trim from the end (most recently added / lowest in the grid) down to the new max.
          // The real cart is reconciled against `selected` at checkout time, so this doesn't
          // need to touch the cart directly.
          var ids = Array.from(selected);
          var toRemove = new Set(ids.slice(newMax));
          picker.querySelectorAll('[data-jb-item]').forEach(function (card) {
            var vid = card.getAttribute('data-variant-id');
            if (toRemove.has(vid)) {
              selected.delete(vid);
              card.setAttribute('data-selected', 'false');
              var btn = card.querySelector('[data-jb-add]');
              if (btn) btn.textContent = btn.getAttribute('data-label-add') || btn.textContent;
            }
          });
        }

        max = newMax;
        currentPrice = newPrice;
        picker.setAttribute('data-max', max);
        picker.setAttribute('data-bundle-price', currentPrice);
        if (subtextEl) subtextEl.textContent = subtextTemplate.replace('[count]', max);
        refresh();
      }

      if (tierWrap) {
        tierWrap.querySelectorAll('[data-tier-count]').forEach(function (tierBtn) {
          tierBtn.addEventListener('click', function () { activateTier(tierBtn); });
        });
      }

      // The next tier up (smallest tier count greater than the current max),
      // used to offer an upsell straight from the "you've hit the limit" toast.
      function findNextTierBtn() {
        if (!tierWrap) return null;
        var next = null;
        tierWrap.querySelectorAll('[data-tier-count]').forEach(function (b) {
          var c = parseInt(b.getAttribute('data-tier-count'), 10);
          if (c > max && (!next || c < parseInt(next.getAttribute('data-tier-count'), 10))) {
            next = b;
          }
        });
        return next;
      }

      picker.querySelectorAll('[data-jb-item]').forEach(function (card) {
        var btn = card.querySelector('[data-jb-add]');
        var addLabel = btn.getAttribute('data-label-add') || btn.textContent;
        var addedLabel = btn.getAttribute('data-label-added') || addLabel;
        btn.addEventListener('click', function () {
          var variantId = card.getAttribute('data-variant-id');
          if (selected.has(variantId)) {
            selected.delete(variantId);
            card.setAttribute('data-selected', 'false');
            btn.textContent = addLabel;
          } else {
            if (selected.size >= max) {
              var nextTierBtn = findNextTierBtn();
              if (nextTierBtn) {
                showToast(maxAlertTemplate.replace('[max]', max), {
                  label: nextTierBtn.textContent,
                  onClick: function () { activateTier(nextTierBtn); }
                });
              } else {
                showToast(maxAlertTemplate.replace('[max]', max));
              }
              return;
            }
            selected.add(variantId);
            card.setAttribute('data-selected', 'true');
            btn.textContent = addedLabel;
          }
          btn.classList.remove('jb-add-btn--pop');
          void btn.offsetWidth;
          btn.classList.add('jb-add-btn--pop');
          refresh();
        });
      });

      if (checkoutBtn) {
        checkoutBtn.addEventListener('click', function () {
          if (selected.size !== max) return;
          checkoutBtn.disabled = true;
          if (checkoutLabelEl) checkoutLabelEl.textContent = addingText;

          function goToBundlerCheckout() {
            // Bundler's discount is only actually generated (as a real
            // Shopify discount) once bndlr.checkout() runs client-side
            // after items are confirmed in the cart -- their "display
            // discounts in cart" setting only shows a cart-level PREVIEW,
            // it does not itself apply a real discount. So this call is
            // required, and it also navigates the customer straight to
            // checkout with the discount already applied.
            if (window.bndlr && typeof window.bndlr.checkout === 'function') {
              // bndlr.checkout() opens Bundler's own full-screen checkout
              // overlay (order recap, discount progress, its own "Finalizar
              // Pedido" button) and keeps it open for several seconds before
              // it finally redirects to Shopify checkout -- hide our own
              // button so it doesn't sit on top of that overlay's UI.
              if (stickybar) stickybar.classList.add('jb-fab--hidden');
              window.bndlr.checkout();
              // Safety net only, not a normal-path timer: Bundler's overlay
              // routinely stays open for a few seconds as part of its usual
              // flow, so this needs to be well past that -- long enough that
              // it never fires during a normal checkout (the page navigates
              // away first), but still recovers the button if bndlr.checkout()
              // ever fails outright without navigating or throwing.
              setTimeout(function () {
                checkoutBtn.disabled = selected.size !== max;
                if (checkoutLabelEl) checkoutLabelEl.textContent = checkoutLabel;
                if (stickybar) stickybar.classList.remove('jb-fab--hidden');
              }, 7000);
            } else {
              if (checkoutLabelEl) checkoutLabelEl.textContent = checkoutLabel;
              refresh();
            }
          }

          function handleError(err) {
            console.error(err);
            showToast(errorText);
            checkoutBtn.disabled = false;
            if (checkoutLabelEl) checkoutLabelEl.textContent = checkoutLabel;
          }

          function addAll() {
            var items = Array.from(selected).map(function (id) {
              return { id: id, quantity: 1 };
            });
            return fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ items: items })
            }).then(function (res) {
              if (!res.ok) throw new Error('Add to cart failed');
            });
          }

          if (!cartMightBeStale) {
            // Nothing from this collection was in the cart at page load, and
            // nothing's been removed since (removal is only ever possible
            // once something real is confirmed in the cart) -- so there's
            // nothing to reconcile. Skip the /cart.js pre-check entirely and
            // add straight away; this is the path most first-time shoppers
            // take, and it saves a full round trip off the checkout delay.
            addAll().then(goToBundlerCheckout).catch(handleError);
            return;
          }

          // Every variant id that belongs to this picker's grid -- used to
          // scope cart reconciliation to only this collection's products,
          // so unrelated items elsewhere in the cart are never touched.
          // Deliberately done ONLY here (at checkout click), not on every
          // individual select/deselect -- firing /cart/add.js per click
          // makes the store's cart drawer pop open on every tap, which is
          // far more disruptive than a single reconciliation right before
          // the redirect to checkout.
          var collectionVariantIds = {};
          picker.querySelectorAll('[data-jb-item]').forEach(function (card) {
            collectionVariantIds[card.getAttribute('data-variant-id')] = true;
          });

          fetch('/cart.js')
            .then(function (res) { return res.ok ? res.json() : { items: [] }; })
            .then(function (cart) {
              var cartVariantIds = {};
              var removeUpdates = {};
              var hasRemovals = false;
              (cart.items || []).forEach(function (it) {
                var vid = String(it.variant_id);
                cartVariantIds[vid] = true;
                if (collectionVariantIds[vid] && !selected.has(vid)) {
                  removeUpdates[it.key] = 0;
                  hasRemovals = true;
                }
              });

              var removeStep = hasRemovals
                ? fetch('/cart/update.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ updates: removeUpdates })
                  }).then(function (res) {
                    if (!res.ok) throw new Error('Cart update failed');
                  })
                : Promise.resolve();

              return removeStep.then(function () {
                var idsToAdd = Array.from(selected).filter(function (id) {
                  return !cartVariantIds[id];
                });
                if (idsToAdd.length === 0) return;

                var items = idsToAdd.map(function (id) {
                  return { id: id, quantity: 1 };
                });
                return fetch('/cart/add.js', {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify({ items: items })
                }).then(function (res) {
                  if (!res.ok) throw new Error('Add to cart failed');
                });
              });
            })
            .then(goToBundlerCheckout)
            .catch(handleError);
        });
      }

      // Since checkout reconciles the cart in one shot (see above), there's
      // no in-page "undo" moment during browsing -- the real cart only gets
      // touched when FINALIZAR COMPRA is clicked. So on load, check what's
      // already in the customer's cart and pre-select any matching products
      // from this collection (up to the current tier's max), so the picker
      // reflects a cart they may have left mid-checkout. This is a one-time
      // sync (page load only), not a live listener -- if they edit their
      // cart in another tab and come back without reloading, this page
      // won't know until it's reloaded.
      function syncFromCart() {
        fetch('/cart.js')
          .then(function (res) { return res.ok ? res.json() : null; })
          .then(function (cart) {
            if (!cart || !cart.items) return;
            var cartVariantIds = {};
            cart.items.forEach(function (it) {
              cartVariantIds[String(it.variant_id)] = true;
            });

            // The picker always starts on the default (smallest) tier on a
            // fresh page load -- tier choice isn't persisted. If the cart
            // already has more matching pieces than that tier's max (e.g.
            // customer picked the 7-tier, went to checkout, then hit Back),
            // switch to the smallest tier that can fit them all first, so
            // the count/price shown actually reflects the real cart instead
            // of silently truncating to the default tier's max.
            var matchCount = 0;
            picker.querySelectorAll('[data-jb-item]').forEach(function (card) {
              if (cartVariantIds[card.getAttribute('data-variant-id')]) matchCount++;
            });
            if (matchCount > 0) cartMightBeStale = true;
            if (matchCount > max && tierWrap) {
              var candidates = Array.from(tierWrap.querySelectorAll('[data-tier-count]')).sort(function (a, b) {
                return parseInt(a.getAttribute('data-tier-count'), 10) - parseInt(b.getAttribute('data-tier-count'), 10);
              });
              var target = candidates.filter(function (b) {
                return parseInt(b.getAttribute('data-tier-count'), 10) >= matchCount;
              })[0] || candidates[candidates.length - 1];
              if (target) activateTier(target);
            }

            picker.querySelectorAll('[data-jb-item]').forEach(function (card) {
              if (selected.size >= max) return;
              var vid = card.getAttribute('data-variant-id');
              if (cartVariantIds[vid] && !selected.has(vid)) {
                selected.add(vid);
                card.setAttribute('data-selected', 'true');
                var btn = card.querySelector('[data-jb-add]');
                if (btn) btn.textContent = btn.getAttribute('data-label-added') || btn.textContent;
              }
            });
            refresh();
          })
          .catch(function () {
            // Non-critical -- if this fails, the picker just starts empty.
          });
      }

      refresh();
      syncFromCart();
    });
  }

  function initGallery() {
    var modal = document.querySelector('[data-jb-modal]');
    if (!modal) return;
    var imgEl = modal.querySelector('[data-jb-modal-image]');
    var titleEl = modal.querySelector('[data-jb-modal-title]');
    var dotsEl = modal.querySelector('[data-jb-modal-dots]');
    var prevBtn = modal.querySelector('[data-jb-modal-prev]');
    var nextBtn = modal.querySelector('[data-jb-modal-next]');
    var images = [];
    var index = 0;

    function render() {
      if (!images.length) return;
      // Fade the current image out immediately and only fade the new one
      // back in once it has actually finished loading -- otherwise the
      // shared <img> element keeps showing the PREVIOUS product's photo for
      // as long as the new one takes to fetch/decode, which looks like a
      // stale/wrong image flashing for a moment.
      imgEl.style.opacity = '0';
      imgEl.onload = function () { imgEl.style.opacity = '1'; };
      imgEl.onerror = function () { imgEl.style.opacity = '1'; };
      imgEl.src = images[index];
      if (dotsEl) {
        dotsEl.innerHTML = '';
        images.forEach(function (_, i) {
          var dot = document.createElement('span');
          dot.className = 'jb-modal__dot' + (i === index ? ' is-active' : '');
          dot.addEventListener('click', function () { index = i; render(); });
          dotsEl.appendChild(dot);
        });
      }
      var multi = images.length > 1;
      if (prevBtn) prevBtn.style.display = multi ? '' : 'none';
      if (nextBtn) nextBtn.style.display = multi ? '' : 'none';
      if (dotsEl) dotsEl.style.display = multi ? '' : 'none';
    }

    function openWithCard(card) {
      var raw = card.getAttribute('data-images');
      try {
        images = JSON.parse(raw || '[]').filter(Boolean);
      } catch (e) {
        images = [];
      }
      if (!images.length) {
        var fallbackImg = card.querySelector('.jb-card__image img');
        if (fallbackImg) images = [fallbackImg.src];
      }
      if (!images.length) return;
      index = 0;
      if (titleEl) titleEl.textContent = card.getAttribute('data-title') || '';
      render();
      modal.classList.add('jb-modal--open');
      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }

    function close() {
      modal.classList.remove('jb-modal--open');
      modal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        index = (index - 1 + images.length) % images.length;
        render();
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        index = (index + 1) % images.length;
        render();
      });
    }
    modal.querySelectorAll('[data-jb-modal-close]').forEach(function (el) {
      el.addEventListener('click', close);
    });
    document.addEventListener('keydown', function (e) {
      if (!modal.classList.contains('jb-modal--open')) return;
      if (e.key === 'Escape') close();
      if (e.key === 'ArrowLeft' && prevBtn) prevBtn.click();
      if (e.key === 'ArrowRight' && nextBtn) nextBtn.click();
    });

    // Clicking a card's image or title opens the gallery for that product;
    // clicks on the ADD button itself must NOT trigger it.
    document.querySelectorAll('[data-jb-item]').forEach(function (card) {
      var imageWrap = card.querySelector('.jb-card__image');
      var titleWrap = card.querySelector('.jb-card__title');
      function trigger(e) {
        if (e.target.closest('[data-jb-add]')) return;
        openWithCard(card);
      }
      if (imageWrap) imageWrap.addEventListener('click', trigger);
      if (titleWrap) titleWrap.addEventListener('click', trigger);
    });
  }

  function installClickRescue() {
    // A third-party overlay (seen on this store: a "ppspy-exp-view-root" div)
    // sits on top of our floating button in hit-testing order regardless of
    // z-index or DOM position, so real clicks land on it instead of us.
    // Rather than fight that stacking war, catch every click at the document
    // level during the CAPTURE phase (before it reaches whatever overlay is
    // on top), check if the pointer coordinates land inside our checkout
    // button's box, and if so fire the button's own click handler directly --
    // it doesn't matter what element the browser thinks was "hit."
    document.addEventListener('click', function (e) {
      var btn = document.querySelector('[data-jb-checkout]');
      if (!btn || btn.disabled) return;
      if (e.target === btn || btn.contains(e.target)) return; // real click already landed correctly
      var r = btn.getBoundingClientRect();
      if (e.clientX >= r.left && e.clientX <= r.right && e.clientY >= r.top && e.clientY <= r.bottom) {
        e.preventDefault();
        e.stopPropagation();
        btn.click();
      }
    }, true);
  }

  function bringFabToFront() {
    // Belt-and-suspenders on top of the z-index bump in CSS: re-parent the
    // floating checkout button (and toast) as the very last nodes in <body>.
    // If a third-party widget's overlay ever ties us on z-index, later DOM
    // position wins the stacking fight, so this keeps us on top of anything
    // inserted before this point.
    document.querySelectorAll('.jb-fab').forEach(function (el) {
      document.body.appendChild(el);
    });
    if (jbToastEl) document.body.appendChild(jbToastEl);
  }

  function watchForOverlayIntrusions() {
    // On desktop specifically, a "ppspy-exp-view-root" widget was found to
    // load and append itself to <body> AFTER our one-time bringFabToFront()
    // call on DOMContentLoaded -- so it ends up later in DOM order and
    // visually paints over our button even though both share the same max
    // z-index (ties go to later-in-DOM at the same stacking level). Watch
    // <body> for new children and, whenever something lands after our fab,
    // re-assert our button as the last child. The "already last" guard
    // keeps this from looping on the mutation it itself causes.
    var observer = new MutationObserver(function () {
      var body = document.body;
      var fabs = document.querySelectorAll('.jb-fab');
      if (!fabs.length) return;
      var lastFab = fabs[fabs.length - 1];
      var expectedLast = jbToastEl || lastFab;
      if (body.lastElementChild !== expectedLast) {
        bringFabToFront();
      }
    });
    observer.observe(document.body, { childList: true });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initTimers();
    initPickers();
    initGallery();
    bringFabToFront();
    installClickRescue();
    watchForOverlayIntrusions();
  });
})();